<template>
  <div class="footer">
    <div class="store-list width">
      <div class="store-list-content">
        <dl>
          <dt>在线帮助</dt>
          <dd>
            <router-link :to="`/question?id=anchor0`" @click.native="toLink('question')">常见问题</router-link>
          </dd>
          <dd @click="toAskous('http://www.support.philips.com/support/contact/contact_page.jsp;jsessionid=41A74C2E0BB62740DDDEAFF780BA5698.app106-drp1?userCountry=cn&amp;userLanguage=zh')">
            <a href="http://www.support.philips.com/support/contact/contact_page.jsp;jsessionid=41A74C2E0BB62740DDDEAFF780BA5698.app106-drp1?userCountry=cn&amp;userLanguage=zh" target="_blank">联系我们</a>
          </dd>
        </dl>
        <dl>
          <dt>订单说明</dt>
          <dd>
            <router-link :to="`/howbuy?id=getStart`" @click.native="toLink('howbuy')">如何订购</router-link>
          </dd>
          <dd>
            <router-link :to="`/order-delivery?id=orderState`" @click.native="toLink('order-delivery')">订单状态</router-link>
          </dd>
          <dd>
            <router-link :to="`/order-query?id=accountManager`" @click.native="toLink('order-query')">订单查询</router-link>
          </dd>
        </dl>
        <dl>
          <dt>支付方式</dt>
          <dd>
            <router-link :to="`/pay-type?id=weChat`" @click.native="toLink('pay-type')">微信</router-link>
          </dd>
          <dd>
            <router-link :to="`/pay-type?id=aliPay`" @click.native="toLink('pay-type')">支付宝</router-link>
          </dd>
          <!-- <dd>
            <router-link :to="`/pay-type?id=netBank`">网银在线</router-link>
          </dd> -->
        </dl>
        <dl>
          <dt>货物配送</dt>
          <dd>
            <router-link :to="`/order-delivery?id=orderSend`" @click.native="toLink('order-delivery')">配送时间</router-link>
          </dd>
          <dd>
            <router-link :to="`/order-delivery?id=orderGet`" @click.native="toLink('order-delivery')">商品验货与签收</router-link>
          </dd>
        </dl>
        <dl>
          <dt>售后服务</dt>
          <dd>
            <router-link :to="`/sale-after?id=changeRole`" @click.native="toLink('sale-after')">退换货政策</router-link>
          </dd>
          <dd>
            <router-link :to="`/sale-after?id=changeProgress`" @click.native="toLink('sale-after')">退换货流程</router-link>
          </dd>
          <dd>
            <router-link :to="`/sale-after?id=changeRole`" @click.native="toLink('sale-after')">7天无理由退换</router-link>
          </dd>
        </dl>
        <dl class="border0">
          <dt>服务热线</dt>
          <dd>飞利浦官网<br>400-880-0008</dd>
        </dl>
      </div>
    </div>
    <!-- <div class="quicksearch-list width" v-if="category.length">
      <h5>快速找到您所需的产品</h5>
      <div class="quicksearch-list-content">
        <dl v-for="(item, index) in category" :key="index">
          <dt v-if="item.children && item.children.length">{{ item.name }}</dt>
          <dd v-for="(list, two) in item.children" :key="two">
            <router-link :to="`/product-list?oneId=${item.id}&twoId=${list.id}`">{{ list.name }}</router-link>
          </dd>
        </dl>
      </div>
    </div> -->
    <!-- <div class="bottom-list">
      <div class="bottom-list-content width">
        <img src="@/assets/images/philips-footer-logo.png" class="bottom-list-content-center">
        <span class="bottom-list-content-right">
          选择语言：<a href="https://www.philips.com/a-cs/global-country-selector">中文</a>
          <span>&gt;</span>
          <br>官方网站：<a href="http://www.philips.com.cn/" target="_blank">www.philips.com.cn</a>
        </span>
        <div class="bottom-list-content-bottom">
          <a>
            <router-link :to="`/terms`">会员服务协议</router-link>
          </a>|
          <a href="http://www.philips.com.cn/privacypolicy/index.page">隐私条款</a>|
          <a href="http://www.philips.com.cn/terms/index.page">使用条款</a>|
          <a href="http://www.philips.com.cn/siteowner/index.page">关于飞利浦会员商城</a>|
          <a href="http://www.support.philips.com/support/contact/contact_page.jsp;jsessionid=41A74C2E0BB62740DDDEAFF780BA5698.app106-drp1?userCountry=cn&amp;userLanguage=zh">联系</a>|
          <a href="http://www.sitemap.philips.com/sitemap/cn_zh/">站点地图</a>
          <br>
           © Koninklijke Philips N.V.，2004 - 2020。保留所有权利。
          <br>
          <a target="_blank" href="http://www.beian.miit.gov.cn/publish/query/indexFirst.action" style="display:inline-block;text-decoration:none;">沪ICP备09062110号</a>
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602001824" style="display:inline-block;text-decoration:none;">
            <img src="@/assets/images/records.png" style="display: inline-block;width:15px;height:15px;vertical-align:sub;margin-left:5px;">
            <p style="display:inline-block;">沪公网安备31010602001824号</p>
          </a>
          <a target="_blank" href="https://218.242.124.22:8082/businessCheck/verifKey.do?showType=extShow&amp;serial=9031000020180929093619000002868252-SAIC_SHOW_310000-20181218124940105973&amp;signData=MEYCIQDKJO5AgC60fAZiq/Q3eD3jgoTt6s5S5MXJbimgfHukswIhAKUL4RGahB2+N+wV26fs6EIUWbBHAvNaadroK8MAj0YS" style="display:inline-block;text-decoration:none;color:#fff;">
            <img class="lazy" src="@/assets/images/icon-1_t.png" style="display: inline-block;width:20px;height:21px;vertical-align:bottom;margin-left:5px;">
          </a>
        </div>
      </div>
    </div> -->
    <div class="warp-bottom">
      <div class="footer_logo width">
        <div class="footer_logo_left">
          <h3 class="p-body-copy-02">连接至飞利浦</h3>
          <div style="display: flex; align-items: center;">
            <a href="https://www.philips.com.cn/myphilips/myphilips-wechat.html" target="_blank">
              <i @click="toLinkous('wechat')" class="iconfont icon-weixin"></i>
            </a>
            <a style="margin-left: 10px;margin-top: 2px;" href="http://weibo.com/onesmallstep" target="_blank">
              <i @click="toLinkous('weibo')" class="iconfont icon-xinlang"></i>
            </a>
          </div>
        </div>
        <div class="footer_logo_center">
          <img src="../assets/images/philips-footer-logo.png" />
        </div>
        <div class="footer_logo_right" @click="toAskous('https://www.philips.com.cn/')">
          <a target="_blank" href="https://www.philips.com.cn/">跳转飞利浦官网</a>
        </div>
      </div>
      <ul class="p-grid">
        <li class="p-grid-item">
          <router-link :to="`/terms`" @click.native="toLink('terms')">
            <span class="p-text">会员服务协议</span>
          </router-link>
        </li>
        <li class="p-grid-item">
          <router-link :to="`/notice`" @click.native="toLink('notice')">
            <span class="p-text">会员规则</span>
          </router-link>
        </li>
        <li class="p-grid-item" @click="toAskous('https://www.careers.philips.com/cn/zh')">
          <a href="https://www.careers.philips.com/cn/zh" target="_blank">
            <span class="p-text">招贤纳士</span>
          </a>
        </li>
        <li class="p-grid-item" @click="toAskous('http://www.support.philips.com/support/contact/contact_page.jsp?userLanguage=zh&userCountry=cn')">
          <a href="http://www.support.philips.com/support/contact/contact_page.jsp?userLanguage=zh&userCountry=cn" target="_blank">
            <span class="p-text">联系飞利浦</span>
          </a>
        </li>
        <li class="p-grid-item" @click="toAskous('https://www.philips.com.cn/a-w/site-owner.html')">
          <a href="https://www.philips.com.cn/a-w/site-owner.html" target="_blank">
            <span class="p-text">Philips</span>
          </a>
        </li>
        <li class="p-grid-item">
          <!-- <a href="https://www.philips.com.cn/a-w/privacy-notice.html" target="_blank">
            <span class="p-text">隐私权声明</span>
          </a> -->
          <router-link :to="`/privacy`" @click.native="toLink('privacy')">
            <span class="p-text">隐私权声明</span>
          </router-link>
        </li>
        <li class="p-grid-item" @click="toAskous('https://www.philips.com.cn/a-w/cookie-notice.html')">
          <a href="https://www.philips.com.cn/a-w/cookie-notice.html" target="_blank">
            <span class="p-text">Cookie 政策</span>
          </a>
        </li>
        <li class="p-grid-item" @click="toAskous('https://www.philips.com.cn/a-w/terms-of-use.html')">
          <a href="https://www.philips.com.cn/a-w/terms-of-use.html" target="_blank">
            <span class="p-text">使用条款</span>
          </a>
        </li>
        <li class="p-grid-item" @click="toAskous('https://www.philips.com.cn/a-w/security.html')">
          <a href="https://www.philips.com.cn/a-w/security.html" target="_blank">
            <span class="p-text">产品安全</span>
          </a>
        </li>
        <li class="p-grid-item" @click="toAskous('http://www.beian.miit.gov.cn/publish/query/indexFirst.action')">
          <a href="http://www.beian.miit.gov.cn/publish/query/indexFirst.action" target="_blank">
            <span class="p-text">沪ICP备09062110号</span>
          </a>
        </li>
        <li class="p-grid-item" @click="toAskous('http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602001824')">
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010602001824" target="_blank">
            <span class="p-text">沪公网安备31010602001824号</span>
          </a>
        </li>
      </ul>
      <p style="color: #b3c8e6;line-height: 22px;">© Koninklijke Philips N.V.，2018 - 2024。保留所有权利。</p>
    </div>
  </div>
</template>

<script>
import request from '@/assets/js/request'
export default {
  name: 'Footer',
  data () {
    return {
      category: []
    }
  },
  created () {
    // this.initCategory()
  },
  methods: {
    async initCategory () {
      try {
        let res = await request('/gateway/product/product/product-category/list/withChildren', 'get')
        this.category = res.data || []
      } catch (e) {
      }
    },
    toLink(pagename) {
      philips.analytics.trackConversion ({
        name: "interaction",
        description: `links:${pagename}`
      })
    },
    toAskous(link) {
      philips.analytics.trackConversion ({
        name:"exit_link",
        url: link
      })
    },
    toLinkous(type) {
      philips.analytics.trackConversion ({
        name:"follow_us",
        servicename: type	
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    height: auto;
    overflow: hidden;
    margin: 0 auto;
    font-size: 14px;
    background: #fff;
    .store-list {
      clear: both;
      width: 100%;
      margin: 0 auto;
      background: #f2f2f2;
      .store-list-content {
        height: auto;
        overflow: hidden;
        margin: 0 auto;
        padding: 25px 0;
        display: flex;
        align-items: center;
        justify-content: center;
        dl {
          width: 95px;
          height: 130px;
          overflow: hidden;
          float: left;
          border-right: 1px dashed #ccc;
          padding: 0 1.5vw;
          dt {
            clear: both;
            width: 100%;
            color: #337deb;
            font-weight: bold;
            text-align: center;
            padding-top: 1px;
          }
          dd {
            clear: both;
            width: 100%;
            text-align: center;
            margin-top: 14px;
            line-height: 1.4;
            color: #999;
            a:link, a:visited {
              color: #999;
            }
          }
          dd:hover {
            text-decoration: underline;
          }
        }
        .border0 {
          border: 0;
          dd:hover {
            text-decoration: none;
          }
        }
      }
    }
    .quicksearch-list {
      padding: 25px 0;
      h5 {
        color: #999;
        font-size: 16px;
        font-weight: bold;
      }
      .quicksearch-list-content {
        clear: both;
        overflow: hidden;
        margin: 0 auto;
        display: flex;
        dl {
          width: 110px;
          float: left;
          margin-right: 1vw;
          padding-top: 20px;
          dt {
            width: 100%;
            color: #337deb;
            font-weight: bold;
            padding-top: 1px;
          }
          dd {
            clear: both;
            width: 100%;
            margin-top: 14px;
            line-height: 1.4;
            a:link, a:visited {
              color: #999;
            }
          }
        }
      }
    }
    .bottom-list {
      clear: both;
      width: 100%;
      height: 300px;
      overflow: hidden;
      filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr='#052371',endColorStr='#00329f',gradientType='1');
      background: -moz-linear-gradient(left,#052371,#00329f);
      background: -webkit-linear-gradient(left,#052371,#00329f);
      background: -ms-linear-gradient(left,#052371,#00329f);
      background: linear-gradient(left,#052371,#00329f);
      a {
        display: inline;
      }
      .bottom-list-content {
        height: 300px;
        margin: 0 auto;
        background: transparent;
        color: #b3d4fc;
        position: relative;
        .bottom-list-content-center {
          position: absolute;
          width: 80px;
          height: auto;
          left: 50%;
          transform: translateX(-50%);
          top: 45px;
        }
        .bottom-list-content-right {
          position: absolute;
          line-height: 1.6;
          left: calc(50% + 15vw);
          top: 75px;
          a:link, a:visited {
            color: #b3d4fc;
          }
          span {
            margin-left: 5px;
            font-family: simHei;
          }
        }
      }
      .bottom-list-content-bottom {
        position: absolute;
        width: 100%;
        height: auto;
        left: 0;
        top: 190px;
        text-align: center;
        line-height: 1.8;
        a:link, a:visited {
          color: #b3d4fc;
          margin: 0 4px 0 0;
          padding: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue